module.exports = __webpack_public_path__ + "static/media/req-workspace-seller-lawyer-help1.dee6985f.svg";